export const secondaryColorScale = {
    0: "#000000",
    5: "#001413",
    10: "#051F1E",
    15: "#102A28",
    20: "#1C3533",
    25: "#27403E",
    30: "#324B49",
    35: "#3F5755",
    40: "#4A6361",
    50: "#627C7A",
    60: "#7C9693",
    70: "#96B0AE",
    80: "#B1CCC9",
    90: "#CCE8E5",
    95: "#DBF6F3",
    98: "#EBFDFA",
    99: "#F2FFFD",
    100: "#FFFFFF",
};
